import API from 'vue-lsi-util/APIAccesoV2'

//const serverAPI= process.env.NODE_ENV=="development" ? "http://127.0.0.1:8080/apiv3" : "https://apiv3.area54sa.com.ar:8125/apiv3"
//const serverAPI= "https://apiv3.area54sa.com.ar:8125/apiv3"

const guias= {
    async getByComprobante(comprobante) {
        return new Promise (
            function (resolve, reject) {
                API.acceder(
                    {
                        //Ruta: serverAPI+'/Guia/ByComprobante/'+comprobante,
                        Ruta: '/Guia/ByComprobante/'+comprobante,
                        Cartel: "Buscando guía..."
                    }
                )
                .then(data => {
                    resolve(data)
                })
                .catch(puteada => { 
                    reject(puteada) 
                })
            }
        )            
    },
}

export default guias